import { render, staticRenderFns } from "./addPurchaseReturn.vue?vue&type=template&id=ef4ab048&scoped=true&"
import script from "./addPurchaseReturn.vue?vue&type=script&lang=js&"
export * from "./addPurchaseReturn.vue?vue&type=script&lang=js&"
import style0 from "./addPurchaseReturn.vue?vue&type=style&index=0&id=ef4ab048&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef4ab048",
  null
  
)

export default component.exports